export default {"src":"/_next/static/media/premium.f659a78b.svg","height":22,"width":127,"blurWidth":0,"blurHeight":0};